import { useBooleanState } from '@calendly/hooks';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const CODE_LENGTH = 6;
const ALLOWED_KEYS = new Set(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End']);
const cursorHiderIsSmallPhoneCss = "c1jqu20";
const cursorHiderCss = "c2pmwj8";
const CursorHider = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isSmallPhone = useDeviceType('isSmallPhone');
  return <Component ref={ref} {...restProps} className={classNames(cursorHiderCss, {
    [cursorHiderIsSmallPhoneCss]: isSmallPhone
  }, props.className)} />;
});
const virtualCaretCss = "vbf76t4";
const VirtualCaret = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(virtualCaretCss, props.className)} />;
});
const displayWrapperCss = "d15q1dn";
const DisplayWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(displayWrapperCss, props.className)} />;
});
const displayFilledCss = "dc7u7jq";
const displayIsErrorCss = "d1q96lmm";
const displayIsSmallPhoneCss = "d1fqlus9";
const displayCss = "d1jr4u3i";
const Display = forwardRef((props, ref) => {
  const {
    filled,
    isError,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isSmallPhone = useDeviceType('isSmallPhone');
  return <Component ref={ref} {...restProps} className={classNames(displayCss, {
    [displayFilledCss]: filled,
    [displayIsErrorCss]: isError,
    [displayIsSmallPhoneCss]: isSmallPhone
  }, props.className)} />;
});
const inputBoxCss = "i1lh5ycv";
const InputBox = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(inputBoxCss, props.className)} />;
});
const styledEmailVerificationInputIsSmallPhoneCss = "s17q7lke";
const styledEmailVerificationInputCss = "shl4vsm";
const StyledEmailVerificationInput = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'input';
  const isSmallPhone = useDeviceType('isSmallPhone');
  return <Component ref={ref} {...restProps} className={classNames(styledEmailVerificationInputCss, {
    [styledEmailVerificationInputIsSmallPhoneCss]: isSmallPhone
  }, props.className)} />;
});
const fieldBlockCss = "fy4sf4a";
const FieldBlock = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(fieldBlockCss, props.className)} />;
});
const CELLS = Array.from({
  length: CODE_LENGTH
}, (_, index) => index);
export const EmailVerificationInput = ({
  disabled = false,
  error,
  value,
  onChange,
  onFocus
}) => {
  const [virtualCaret, showVirtualCaret, hideVirtualCaret] = useBooleanState(false);
  const digits = value.split('');
  const showCaret = digits.length === CODE_LENGTH && virtualCaret;
  const cleanInput = input => (input || '').replace(/\D/g, '').substring(0, CODE_LENGTH);
  const handleKeyPress = e => {
    if (!ALLOWED_KEYS.has(e.key)) {
      e.preventDefault();
    }
  };
  const handleOnChange = e => {
    const newValue = cleanInput(e.target.value);
    onChange(newValue, newValue.length === CODE_LENGTH);
  };
  const handleOnPaste = e => {
    e.preventDefault();
    const pasteText = cleanInput(e.clipboardData.getData('Text'));
    onChange(pasteText, pasteText.length === CODE_LENGTH);
  };
  return <FieldBlock>
      <InputBox>
        <StyledEmailVerificationInput disabled={disabled} type="text" name="verification_code" value={value} maxLength={CODE_LENGTH} onKeyPress={handleKeyPress} onChange={handleOnChange} onPaste={handleOnPaste} onSelect={e => {
        if (e.target.selectionStart === CODE_LENGTH && e.target.selectionEnd === CODE_LENGTH) {
          showVirtualCaret();
        } else {
          hideVirtualCaret();
        }
      }} onFocus={onFocus} />
        <DisplayWrapper>
          {CELLS.map(index => <Display key={index} filled={Boolean(digits[index])} isError={!!error}>
                                {showCaret && index === CODE_LENGTH - 1 && <VirtualCaret />}
                              </Display>)}
          <CursorHider />
        </DisplayWrapper>
      </InputBox>
    </FieldBlock>;
};

require("./email_verification_input.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./email_verification_input.js");